module.exports = __webpack_public_path__ + "static/media/sprite-student-portal.3288b41a.png";